import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white px-4">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <div className="text-9xl font-bold text-blue-600 opacity-20">404</div>
          <h1 className="text-3xl font-bold text-gray-800 mt-4">Página no encontrada</h1>
          <p className="text-gray-600 mt-2">
            La página que estás buscando no existe o ha sido movida.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Home size={20} />
            Volver al Inicio
          </Link>
          
          <div className="text-sm text-gray-500">
            <p>O contacta con nosotros:</p>
            <div className="mt-2 space-x-4">
              <a href="tel:+541112345678" className="text-blue-600 hover:underline">
                📞 +54 11 1234-5678
              </a>
              <a href="https://wa.me/5491112345678" className="text-green-600 hover:underline">
                💬 WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;